import common from './common';
import main from './main';

const ja = { common, main };
export default ja;
